import React from 'react';
import classNames from 'classnames/bind';
import { useTheme } from '@components/theme';
import styles from './LocationPageHero.module.scss';
import Image from '../Image/Image';

interface ILocationPageHeroProps {
  className?: string;
  backgroundColor?: string;
  overlineText?: string;
  title: string;
  mainImage?: string;
  smallImage?: string;
}

const LocationPageHero = ({
  className = '',
  backgroundColor,
  overlineText,
  title,
  mainImage,
  smallImage,
}: ILocationPageHeroProps) => {
  const theme = useTheme();

  const defaultSmallImage = 'https://s3.us-east-1.amazonaws.com/static.havenly.com/prod/assets/hero_2_cropped.jpg';
  const defaultMainImage = 'https://s3.us-east-1.amazonaws.com/static.havenly.com/prod/assets/hero_1_cropped.jpg';

  return (
    <div
      className={
        classNames(
          theme.styles.Section,
          styles.Container,
          className
        )
      }
      style={{ backgroundColor: backgroundColor || theme.colors.tint1 }}
    >
      <div className={styles.Shell}>
        <div
          className={styles.Images}
        >
          <Image
            className={styles.SmallImage}
            width={235}
            height={196}
            src={smallImage || defaultSmallImage}
            fit="fit-in"
            objectFit="cover"
            placeholder="blur"
            alt="small hero image"
          />
          <div style={{ width: 470 }}>
            <Image
              className={styles.MainImage}
              width={470}
              height={392}
              src={mainImage || defaultMainImage}
              sizes="(max-width: 700px) 60vw, 470px"
              loading="eager"
              priority
              fit="fit-in"
              objectFit="cover"
              placeholder="blur"
              alt="large hero image"
            />
          </div>
        </div>
        <div className={styles.Wrapper}>
          {overlineText && (
            <span className={classNames(theme.styles.Overline, styles.Overline)}>
              {overlineText}
            </span>
          )}
          <h1
            data-test="HeroTitle"
            className={classNames(styles.Title)}
          >
            {title}
          </h1>
        </div>
      </div>

    </div>
  );
};

export default LocationPageHero;
